import ExcelJS from 'exceljs';
import updateToken from '@/middlewares/updateToken-middleware';

async function generateXLS(documento) {
  // Atualiza o token
  updateToken();

  const workbook = new ExcelJS.Workbook();
  documento.planilhas.forEach((p) => {
    const worksheet = workbook.addWorksheet(p.titulo);
    worksheet.columns = p.colunas;
    p.dados.forEach((d) => worksheet.addRow(d));
    for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex += 1) {
      worksheet.getRow(rowIndex).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const a = document.createElement('a');
  const url = URL.createObjectURL(blob);
  a.style.display = 'none';
  a.href = url;
  a.download = `${documento.titulo}.xlsx`;
  document.body.appendChild(a);
  a.onclick = async () => {
    document.body.removeChild(a);
    await new Promise((resolve) => setTimeout(resolve, 10000));
    URL.revokeObjectURL(url);
  };
  a.click();
}

export { generateXLS };
